<hb-table [config]="tableConfig" [data]="tableData" (loadLazy)="lazyLoad($event)"></hb-table>